export default __webpack_public_path__ + "question.png?4b0b6b05c5df4712c167989c554364e4";